// extracted by mini-css-extract-plugin
export default {"column":"Column_column__ODJ2y","title":"Column_title__vE1E1"};